<template>
	  <!-- <section class="bg-white dark:bg-gray-900">
    <div class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
        <img class="w-full dark:hidden" src="../assets/sponsor/crbnWL.svg" alt="dashboard image">
        <img class="w-full hidden dark:block" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/cta/cta-dashboard-mockup-dark.svg" alt="dashboard image">
        <div class="mt-4 md:mt-0">
            <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">Let's create more tools and ideas that brings us together.</h2>
            <p class="mb-6 font-light text-gray-500 md:text-lg dark:text-gray-400">Flowbite helps you connect with friends and communities of people who share your interests. Connecting with your friends and family as well as discovering new ones is easy with features like Groups.</p>
            <a href="#" class="inline-flex items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
                Get started
                <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </a>
        </div>
    </div>
	</section> 
	<section class="bg-white dark:bg-gray-900">
    <div class="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
        <div class="font-light text-gray-500 sm:text-lg dark:text-gray-400">
            <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">We didn't reinvent the wheel</h2>
            <p class="mb-4">We are strategists, designers and developers. Innovators and problem solvers. Small enough to be simple and quick, but big enough to deliver the scope you want at the pace you need. Small enough to be simple and quick, but big enough to deliver the scope you want at the pace you need.</p>
            <p>We are strategists, designers and developers. Innovators and problem solvers. Small enough to be simple and quick.</p>
        </div>
        <div class="grid grid-cols-2 gap-4 mt-8">
            <img class="w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/content/office-long-2.png" alt="office content 1">
            <img class="mt-4 w-full lg:mt-10 rounded-lg" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/content/office-long-1.png" alt="office content 2">
        </div>
    </div>
</section> -->	

    <section class="dark:bg-gray-800 dark:text-gray-100">
		<div class="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl">
            <div>
				<h2 class="text-3xl font-bold tracking-tight text-center sm:text-5xl dark:text-gray-50">Walter Lau Pickleball</h2>
				<p class="max-w-3xl mx-auto mt-4 text-xl text-center dark:text-gray-primary"></p>
            </div>
            <div id="accordion-open" data-accordion="open" class="rounded-base border border-default overflow-hidden shadow-xs">
                <h2 id="accordion-open-heading-1">
                    <button type="button" class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-body rounded-t-base border border-t-0 border-x-0 border-b-default hover:text-heading hover:bg-neutral-secondary-medium gap-3" data-accordion-target="#accordion-open-body-1" aria-expanded="true" aria-controls="accordion-open-body-1">
                    <span class="flex items-center font-semibold text-3xl">Bio</span>
                    <svg data-accordion-icon class="w-5 h-5 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/></svg>
                    </button>
                </h2>
                <div id="accordion-open-body-1" class="hidden border border-s-0 border-e-0 border-t-0 border-b-default" aria-labelledby="accordion-open-heading-1">
                    <div class="p-4 md:p-5">
                    <p class="mb-2 text-xl text-left leading-loose text-body">
                        Walter Lau started playing pickleball in 2020 after over two decades of coaching and competing in tennis and has never looked back since.  With his experience in a plethora of racket sports such as ping pong, badminton, & racquetball, as well others such as basketball, football, and track, Walter offers a unique perspective with the ability to adapt various kinetic movements & athletic backgrounds into his training, coaching, and commentating.  With his gold medal-winning performances at numerous local tournaments and even nationally at Nationals and the U.S. Open, he decided to take that same golden standard into teaching the game he is so passionate about.  He has since taught numerous clinics with top pros such as Jay Devilliers, Callie Smith, Jessie Irvine, and more.  He has also coached/trained several pro & senior pro athletes from pickleball and other sports too [including Golden Tate, James Blake, and Michael Chang to name a few].  Life Time is looking forward to having him call Life Time here his permanent home!
                    </p>      
                    </div>
                </div>
                <h2 id="accordion-open-heading-2">
                    <button type="button" class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-body border border-x-0 border-b-default border-t-0 hover:text-heading hover:bg-neutral-secondary-medium gap-3" data-accordion-target="#accordion-open-body-2" aria-expanded="false" aria-controls="accordion-open-body-2">
                    <span class="flex items-center font-semibold text-3xl">PickleBall Accolades</span>
                    <svg data-accordion-icon class="w-5 h-5 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/></svg>
                    </button>
                </h2>
                <div id="accordion-open-body-2" class="hidden border border-s-0 border-e-0 border-t-0 border-b-default" aria-labelledby="accordion-open-heading-2">
                    <div class="p-4 md:p-5">
                    <p class="mb-2 text-body">
                        <ul class="text-left space-y-1 text-body list-disc list-inside">
                            <li  >
                                2025 Commentator & Analyst for Major League Pickleball in June at the San Clemente Event
                            </li>
                            <li  >
                                2025 Commentator & Analyst for our very own PPA Tour Life Time OC Cup Tournament held in June 
                            </li>
                            <li  >
                                2024 Commentator & Analyst for our very own PPA Tour Life Time OC Cup Tournament held in June 
                            </li>
                            <li>
                                2024 Sketchers Paris Open Finalist (Paris, France)
                            </li>
                            <li>
                                2023 PPA Tour LA Open Pro Points Draw Gold Medalist
                            </li>
                            <li>
                                2022 & 2023 Life Time Rancho San Clemente PPA OC Cup Tournament 5.0 19+ 2X Defending Gold Medalist
                            </li>
                            <li>
                                2022 Minto US Open 5.0 19+ Champion (Naples, FL) 
                            </li>
                            <li>
                                2022 Margaritaville Nationals 5.0 19+ Champion (Indian Wells Tennis Garden, CA) 
                            </li>
                            <li>
                                DUPR Rating:  Nationally Ranked #23 in DUPR’s Top 50 Players by Region (CA & HI) by The Dink Publication '22 - DUPR Rating 5.9 as of 12/23
                            </li>
                            <li>
                                IFP Certified & Insured Pickleball Instructor – Advanced/Plus (4.5+)
                            </li>
                            <li>
                                2024 Sketchers Paris Open Finalist (Paris, France)
                            </li>
                            <li>
                                Selected as a USA Pickleball Ambassador by USA Pickleball and currently a Sponsored Pro Pickleball Player by companies such as CRBN, Memorial Care, Crown Picklball, Pendulum, and MyPadL, etc.
                            </li>
                            <li>
                                Pickleball Director at El Camino Country Club and elected by the Board as Resident Pickleball Pro for The Fairbanks Ranch Estates HOA (Rancho Santa Fe, CA)
                            </li>
                            <li>
                                Pickleball Pro at Bay Club (Carmel Valley, CA); Fairbanks Ranch Country Club (Rancho Santa Fe, CA); and The Bridges Country Club (Rancho Santa Fe, CA)
                            </li>
                            <li>
                                Coaching affiliate with Nike, Tyson McGuffin, and other Pickleball Camps [coaching alongside Jay Devilliers, Callie Jo Smith, Jessie Irvine, Kyle McKenzie, and others touring pros as well]
                            </li>
                            <li>
                                Coached/trained several pro & senior pro athletes from pickleball and other sports too:  Golden Tate, James Blake, Michael Chang, etc.
                            </li>                           
                        </ul>        
                    </p>
                    
                    </div>
                </div>            
                <h2 id="accordion-open-heading-3">
                    <button type="button" class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-body border border-x-0 border-b-default border-t-0 hover:text-heading hover:bg-neutral-secondary-medium gap-3" data-accordion-target="#accordion-open-body-3" aria-expanded="false" aria-controls="accordion-open-body-3">
                    <span class="flex items-center font-semibold text-3xl">Personal Training and Professional Experience</span>
                    <svg data-accordion-icon class="w-5 h-5 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/></svg>
                    </button>
                </h2>
                <div id="accordion-open-body-3" class="hidden border border-s-0 border-e-0 border-t-0 border-b-default" aria-labelledby="accordion-open-heading-3">
                    <div class="p-4 md:p-5">
                    <p class="mb-2 text-body">
                        <ul class="text-left space-y-1 text-body list-disc list-inside">
                            <li  >
                                Previously-NCCPT Certified Personal Trainer at LA Fitness
                            </li>
                            <li  >
                                IP Patent Prosecution experience working at various large Law Firms and In-House 
                            </li>
                            <li  >
                                Medical Device & Bracing and Support Industry experience working as a Product Manager
                            </li>                                               
                        </ul>        
                    </p> 
                    </div>                   
                </div>                
                <h2 id="accordion-open-heading-4">
                    <button type="button" class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-body hover:text-heading hover:bg-neutral-secondary-medium gap-3" data-accordion-target="#accordion-open-body-4" aria-expanded="false" aria-controls="accordion-open-body-4">
                    <span class="flex items-center font-semibold text-3xl"> Tennis Accolades</span>
                    <svg data-accordion-icon class="w-5 h-5 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/></svg>
                    </button>
                </h2>
                <div id="accordion-open-body-4" class="hidden" aria-labelledby="accordion-open-heading-4">
                    <div class="p-4 md:p-5 border border-t-default border-b-0 border-x-0">
                        <ul class="text-left space-y-1 text-body list-disc list-inside">
                            <li  >
                                USTA Singles Ranking: Top 8 in Southern California and Top 160 in the Nation; USTA Doubles Ranking: Top 4 in Southern California
                            </li>
                            <li  >
                                Varsity Tennis at FVHS - 4 yrs. at the Varsity #1 Singles position (MVP & All-Sunset League Team Twice) 
                            </li>
                            <li  >
                                Set Personal and School Season Record:  40-7 
                            </li>
                            <li>
                                4-Star Recruit to UC San Diego for Tennis with 75+ 1st & 2nd place USTA singles/doubles tournament finishes
                            </li>
                        </ul>        
                    </div>
                </div>
            
        </div>
			
			<div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
				<div>
					<h3 class="text-2xl font-bold tracking-tight sm:text-3xl dark:text-gray-50">CRBN & Life Time Sponsored
                         Pro Pickleball Player, Director, Coach, and Commentator.</h3>
					<!-- <p class="mt-3 text-lg dark:text-gray-primary">Cu imperdiet posidonium sed</p> -->
					<div class="mt-12 space-y-12">
						<div class="flex">
							<div class="flex-shrink-0">
								<div class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-walter-primary dark:text-gray-900">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-7 h-7">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
									</svg>
								</div>
							</div>
							<div class="ml-4">
								<h4 class="text-lg font-medium leading-6 dark:text-gray-50">Professional</h4>
								<p class="mt-2 dark:text-gray-400">He is currently a sponsored pickleball player competing in tournaments throughout the U.S. He has also been selected as an Ambassador for the USAPA and is a certified coach providing lessons and clinics in San Diego and Orange County</p>
							</div>
						</div>
						<div class="flex">
							<div class="flex-shrink-0">
								<div class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-walter-primary dark:text-gray-900">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-7 h-7">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
									</svg>
								</div>
							</div>
							<div class="ml-4">
								<h4 class="text-lg font-medium leading-6 dark:text-gray-50">Coach</h4>
                                <p class="mt-2 dark:text-gray-400">Walter was a Top-10 ranked junior tennis player in the USTA for both singles & doubles, a 4-star tennis recruit to UCSD, and a tennis and pickleball coach at a number of country clubs in San Diego and Orange County.</p>

							</div>
						</div>
						<div class="flex">
							<div class="flex-shrink-0">
								<div class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-walter-primary dark:text-gray-900">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-7 h-7">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
									</svg>
								</div>
							</div>
							<div class="ml-4">
								<h4 class="text-lg font-medium leading-6 dark:text-gray-50">Leadership</h4>
                                <p class="mt-2 dark:text-gray-400">Walter bings ample experience in directing dynamic clinics, leagues, tournaments, and events.</p>
                                
							</div>
						</div>
					</div>
				</div>
				<div aria-hidden="true" class="mt-10 lg:mt-0">
					<img src="../assets/action/coach2.jpg" alt="" class="mx-auto rounded-lg shadow-lg dark:bg-gray-500">
				</div>
			</div>
			<div>
				<div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
					<div class="lg:col-start-2">
						<!-- <h3 class="text-2xl font-bold tracking-tight sm:text-3xl dark:text-gray-50">Eam nibh gloriatur ex</h3>
						<p class="mt-3 text-lg dark:text-gray-primary">Per odio fabellas consulatu cu. Utroque detracto mel ea, quo te latine theophrastus. Ea his tale nibh dissentias, mei exerci tamquam euripidis cu.</p> -->
						<div class="mt-12 space-y-12">
							<div class="flex">
								<div class="flex-shrink-0">
									<div class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-walter-primary dark:text-gray-900">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-7 h-7">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
										</svg>
									</div>
								</div>
								<div class="ml-4">
									<h4 class="text-lg font-medium leading-6 dark:text-gray-50">Effective </h4>
									<p class="mt-2 dark:text-gray-400">In addition to his tennis experience, Walter was a certified personal trainer who still loves to keep in shape via calisthenics, plyometrics, and by playing competitive sports including basketball, volleyball, and other racket sports such as racquetball, badminton, and ping pong.</p>
								</div>
							</div>
							<div class="flex">
								<div class="flex-shrink-0">
									<div class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-walter-primary dark:text-gray-900">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-7 h-7">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
										</svg>
									</div>
								</div>
								<div class="ml-4">
									<h4 class="text-lg font-medium leading-6 dark:text-gray-50">Community</h4>
									<p class="mt-2 dark:text-gray-400">Be on the lookout for various events he will be putting on for our pickleball community in the upcoming months.</p>
								</div>
							</div>
							<div class="flex">
								<div class="flex-shrink-0">
									<div class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-walter-primary dark:text-gray-900">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-7 h-7">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
										</svg>
									</div>
								</div>
								<div class="ml-4">
									<h4 class="text-lg font-medium leading-6 dark:text-gray-50">Growth</h4>
									<p class="mt-2 dark:text-gray-400">Walter is excited to continue to foster great relationships and continue to grow pickleball for the community while coupling it with networkings, fitness, and fun!</p>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-10 lg:mt-0 lg:col-start-1 lg:row-start-1">
						<img src="../assets/action/coach.jpg" alt="" class="mx-auto rounded-lg shadow-lg dark:bg-gray-500">
					</div>
				</div>
			</div>
		</div>
	</section>   
	<section class="m-4 md:m-8 dark:bg-gray-800 dark:text-gray-100">
		<div class="container mx-auto p-4 my-6 space-y-2 text-center">
			<h2 class="text-5xl font-bold">Positions and Accolades</h2>
			<p class="dark:text-gray-primary">and where to find me</p>
		</div>
		<div class="container mx-auto grid justify-center gap-4 sm:grid-cols-2 lg:grid-cols-3">
			<div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Pro PickleBall Player</h3>
				<div class="space-y-1 leading-tight">
                    <i class='fas fa-medal'></i>
					<p>CRBN and Life Time Sponsored</p>
                    <span>Director, Coach, Commentator</span><br>                       
				</div>
			</div>
			<div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Director</h3>
				<div class="space-y-1 leading-tight">
                    <i class='far fa-compass'></i>
					<p>of Pickleball</p>
                    <span>at Life Time Fitness Laguna Niguel</span><br>
                    
				</div>
			</div>
			<div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Victor</h3>
				<div class="space-y-1 leading-tight">					
                    <i class='fas fa-medal'></i>
                    <p>Two-time Gold Medalist at Nationals, 5.0 19+ </p>
                    <span> Indian Wells Tennis Garden, CALIFORNIA and Dallas, TEXAS</span>                  
				</div>
			</div>

            <div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Gold</h3>
				<div class="space-y-1 leading-tight">					
                    <i class='fas fa-medal'></i>
                    <p>US Open Gold Medalist, 5.0 19+ </p> 
                    <span>Naples, FLORDIA</span>                        
				</div>
			</div>

            <div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Gold</h3>
				<div class="space-y-1 leading-tight">					
                    <i class='fas fa-medal'></i>                  
                    <p>PPA Newport Beach Shootout Backdraw Gold Medalist, Pro Division </p> 
                    <span>Newport Beach, CALIFORNIA</span>         
                 
				</div>
			</div>
            <div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Silver</h3>
				<div class="space-y-1 leading-tight">					
                    <i class='fas fa-medal'></i>                         
                    <p>Sketchers Paris Open Silver Medalist, Pro Division </p> 
                    <span>Paris, FRANCE</span>        
				</div>
			</div>
			<!-- <div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Head Pro</h3>
				<div class="space-y-1 leading-tight">
                    <p>of</p> 
                    <span>Life Time Fitness Laguna Niguel</span>
                    
				</div>
			</div>
			<div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Pickleball Pro</h3>
				<div class="space-y-1 leading-tight">					
                    <span> at Life Time Fitness</span><br>             
                    <p>San Clemente,</p>
                    <i class='fab fa-d-and-d'></i>
                    <p>Laguna Niguel</p>
				</div>
			</div>
			<div class="flex flex-col items-center p-4">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-8 h-8 dark:text-walter-primary">
					<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
				</svg>
				<h3 class="my-3 text-3xl font-semibold">Club Owner</h3>
				<div class="space-y-1 leading-tight">
                    <i class='far fa-compass'></i> <br>
                    <p>Club Owner</p>       
                    <span>DUPR - Walter Lau Pickleball</span> 
				</div>
			</div> -->
		</div>
	</section>
</template>




<script>
import { initTooltips, initDropdowns, initAccordions  } from "flowbite"
import {onMounted, ref} from 'vue'
import { BeakerIcon } from '@heroicons/vue/24/outline'


export default {
    components:{
    BeakerIcon
          
  },
    setup(){
        const dropDowner = ref(['mario', 'lugio', 'peach'])
        const memberTest = ref([
            {id: 1, first: 'billy', last: 'gaonzo', email: 'ger@gmail.com'},            
            {id: 2, first: 'bozo', last: 'sfeged', email: 'gdfeer@gmail.com'}
        ])
        
        const keymaster = Object.keys(memberTest.value[0])
		onMounted(() => {
            initAccordions()			
		});      

        return {dropDowner, memberTest}
    }    
}
</script>

<style >


.panel.about img {
  min-height: 100%;
  min-width: 100%;
   overflow: hidden;
}


</style>